<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :keyStatus="filterProps.status"
      :keyType="filterProps.type"
      :keyName="filterProps.name"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :keyStatus="filterProps.status"
        :keyType="filterProps.type"
        :keyName="filterProps.name"
        @clearKey="clearKey"
        @setWatermark="setWatermark"
        :size="size"
        @openUpload="openUpload"
        @shareAlbum="shareAlbum"
        @openSet="openSet"
      />
      <router-view
        v-if="isSysRights('SupplierAlbum.findBySupplier')"
        :first_loading="firstLoading"
        :items="items"
        @removeProImg="removeProImg"
        :typeName="typeName"
      ></router-view>
      <no-rights v-else></no-rights>
      <pagination
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/product-img/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
      <api-loading :show="loading"></api-loading>
    </div>
    <Modal
      :modalId="'modalSetMark'"
      :home="false"
      :loading="modalSetMark.loading"
      :size="'lg'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("product.设置水印") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <p class="tx-gray-900">{{ $t("product.水印预览") }}</p>
          <div class="d-flex">
            <div class="body-l">
              <div class="watermark wd-300 ht-300 pos-relative">
                <div
                  style="
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.3);
                  "
                ></div>
                <template v-if="modalSetMark.type == 2">
                  <div
                    v-if="modalSetMark.position == 2"
                    class="mark_wrap2 pos-absolute tx-white"
                    :class="{ 'class-b': modalSetMark.position == 2 }"
                  >
                    <span>{{
                      modalSetMark.type == 1 ? "" : $t("product.@公司名称")
                    }}</span>
                  </div>
                  <div
                    class="mark_wrap pos-absolute tx-white"
                    :class="{
                      'class-a': modalSetMark.position == 1,
                      'class-b': modalSetMark.position == 2,
                      'class-c': modalSetMark.position == 3,
                      'class-d': modalSetMark.position == 4,
                    }"
                  >
                    <span>{{
                      modalSetMark.type == 1 ? "" : $t("product.@公司名称")
                    }}</span>
                  </div>
                </template>
              </div>
            </div>
            <div
              class="body-r mg-l-30 pd-l-30 tx-gray-900"
              style="border-left: 1px dashed #ddd"
            >
              <div class="mg-b-20">
                <label class="rdiobox">
                  <input
                    name="type"
                    type="radio"
                    v-model="modalSetMark.type"
                    value="1"
                  />
                  <span>{{ $t("product.不显示水印") }}</span>
                </label>
              </div>
              <div>
                <label class="rdiobox">
                  <input
                    name="type"
                    type="radio"
                    v-model="modalSetMark.type"
                    value="2"
                  />
                  <span>{{ $t("product.显示您的公司名称") }}</span>
                </label>
                <div v-show="modalSetMark.type == 2" class="pd-l-25">
                  <p class="tx-gray-900 mg-b-10 mg-t-15">
                    {{ $t("product.水印位置") }}
                  </p>
                  <label class="rdiobox">
                    <input
                      name="type2"
                      type="radio"
                      v-model="modalSetMark.position"
                      value="3"
                    />
                    <span>{{ $t("product.图片中心") }}</span>
                  </label>
                  <label class="rdiobox">
                    <input
                      name="type2"
                      type="radio"
                      v-model="modalSetMark.position"
                      value="2"
                    />
                    <span>{{ $t("product.左右边角") }}</span>
                  </label>
                  <label class="rdiobox">
                    <input
                      name="type2"
                      type="radio"
                      v-model="modalSetMark.position"
                      value="4"
                    />
                    <span>{{ $t("product.底部居中") }}</span>
                  </label>
                  <label class="rdiobox">
                    <input
                      name="type2"
                      type="radio"
                      v-model="modalSetMark.position"
                      value="1"
                    />
                    <span>{{ $t("product.底部居右") }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-15
                btn btn-primary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
            >
              {{ $t("product.保存") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("product.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <confirmComponent
      @del_index_i="deletesFn"
      :modal_id="delAddr.modalId"
      :modal_title="delAddr.title"
      :modal_text="delAddr.text"
      :del_index="delAddr.delIndex"
    ></confirmComponent>
    <ModalUploadFolder
      :open="openUploadFolder"
      @uploadSuccess="uploadFolderSuccess"
    />
    <ModalUploadPic
      :open="openUploadPic"
      @uploadSuccess="uploadFolderSuccess"
      @createAlbum="getItems"
    />
    <Modal
      :modalId="'modalShareAlbum'"
      :home="false"
      :loading="modalShareAlbum.loading"
      :size="'md'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("product.设置分享相册信息") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
              {{ $t("product.分享链接：") }}
            </label>
            <div
              class="col-md-9 col-sm-12 tx-gray-900 d-flex align-items-center"
            >
              <span>
                <a class="tx-info" :href="userInfo.albumUrl" target="_blank">
                  {{ userInfo.albumUrl }}
                </a>
                <a
                  class="to-clipboard mg-l-5"
                  href="javascript:;"
                  :data-clipboard-text="userInfo.albumUrl"
                >
                  <i class="icon ion-clipboard"></i>
                </a>
              </span>
              <a
                style="white-space: nowrap"
                class="mg-l-30 tx-12 d-flex align-items-center tx-gray-900"
                href="javascript:;"
                data-toggle="tooltip"
                data-placement="bottom"
                :data-original-title="setShareImg"
                data-html="true"
              >
                {{ $t("product.扫一扫 手机看") }}
                <i class="fa fa-qrcode tx-14 mg-l-5"></i>
              </a>
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
              {{ $t("product.联系人") }}：
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900">
              <input
                type="text"
                v-model="modalShareAlbum.contact"
                class="form-control form-control-sm tx-13"
              />
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
              {{ $t("product.手 机") }}：
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900">
              <input
                type="text"
                v-model="modalShareAlbum.mobile"
                class="form-control form-control-sm tx-13"
              />
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
              Q&emsp;Q：
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900">
              <input
                type="text"
                v-model="modalShareAlbum.qq"
                class="form-control form-control-sm tx-13"
              />
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
              {{ $t("product.旺 旺") }}：
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900">
              <input
                type="text"
                v-model="modalShareAlbum.wangwang"
                class="form-control form-control-sm tx-13"
              />
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-5">
            <label class="col-form-label form-control-sm text-right wd-100">
              {{ $t("product.地 址") }}：
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900 d-flex">
              <div class="col pd-l-0">
                <select
                  class="form-control form-control-sm"
                  @change="selectProvince()"
                  v-model="modalShareAlbum.province"
                  name="addressProvince"
                >
                  <option
                    v-for="(province, index) in selectCityArr"
                    :key="index"
                    v-text="province.name"
                    :value="index"
                  ></option>
                </select>
              </div>
              <div class="col">
                <select
                  class="form-control form-control-sm"
                  @change="selectCity()"
                  v-model="modalShareAlbum.city"
                  :disabled="cityArr.length < 1"
                  name="addressCity"
                >
                  <option
                    v-for="(city, index) in cityArr"
                    :key="index"
                    v-text="city.name"
                    :value="index"
                  ></option>
                </select>
              </div>
              <div class="col pd-r-0">
                <select
                  class="form-control form-control-sm"
                  v-model="modalShareAlbum.area"
                  :disabled="areaArr.length < 1"
                  name="addressArea"
                >
                  <option
                    v-for="(area, index) in areaArr"
                    :key="index"
                    v-text="area.name"
                    :value="index"
                  ></option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900">
              <input
                v-model="modalShareAlbum.address"
                class="form-control form-control-sm tx-13"
                :placeholder="$t('product.地址')"
              />
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
              {{ $t("product.邮 编") }}：
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900">
              <input
                type="text"
                v-model="modalShareAlbum.postCode"
                class="form-control form-control-sm tx-13"
              />
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-15
                btn btn-primary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="saveShare"
            >
              {{ $t("product.保存") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("product.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <albumSet :open="albumSetOpen2" @start_pay="startPay"></albumSet>
    <PayMask :code="payCode" @pay_success="paySuccess"></PayMask>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //$t('product.左边栏')
import Header from "./header.vue"; //$t('product.头')
import Modal from "@components/Modal";
import { pagination, innerPagination } from "@components/pagination.js"; //$t('product.分页')
import { confirmComponent } from "@components/components.js"; //$t('product.$t('product.删除')确认')
import ModalUploadFolder from "@components/supplier/modal-upload-folder"; //$t('product.选文件夹上传图片')
import ModalUploadPic from "@components/supplier/modal-upload-pic"; //$t('product.选图片$t('product.文件上传')图片')
import albumSet from "./modal-album-set.vue";
import PayMask from "@components/supplier/pay-mask.vue"; //$t('product.支付等待遮罩')
export default {
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //$t('product.左边栏')状态
      firstLoading: true,
      loading: false,
      page: this.$route.params.page ? this.$route.params.page : 1,
      totalPage: 1,
      rowsPerPage: parseInt(store.get("product-img-rowsPerPage"))
        ? parseInt(store.get("product-img-rowsPerPage"))
        : 10,
      pageSizeSelect: [10, 20, 50],
      totalCount: 0,
      items: [],
      filterProps: {
        status: "",
        type: "",
        clickType: "",
        name: "",
      },
      modalSetMark: {
        loading: false,
        type: 1,
        position: 3,
      },
      delAddr: {
        modalId: "modalDelProImg",
        title: this.$t("product.删除"),
        text: this.$t("product.确定要删除吗"),
        delIndex: "",
      },
      size: "",
      openUploadFolder: Symbol(),
      openUploadPic: Symbol(),
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      modalShareAlbum: {
        loading: false,
        contact: "",
        mobile: "",
        qq: "",
        wangwang: "",
        province: 0,
        city: 0,
        area: "",
        address: "",
        postCode: "",
      },
      selectCityArr: arrCity,
      cityArr: [],
      areaArr: [],
      configInfoCopy: "",
      configInfo: "",
      albumSetOpen2: Symbol(),
      payCode: "",
      typeName: {
        1: this.$t("product.新品"),
        2: this.$t("product.库存"),
        3: this.$t("product.自主添加"),
      },
      setShareImg: "",
    };
  },
  components: {
    ModalUploadPic,
    ModalUploadFolder,
    LeftSide,
    Header,
    Modal,
    pagination,
    confirmComponent,
    innerPagination,
    albumSet,
    PayMask,
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("product-img-rowsPerPage", this.rowsPerPage);
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getItems();
  },
  updated() {
    $('[data-toggle="tooltip"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
  methods: {
    paySuccess(type) {
      if (type) {
        $.api_call("api.User.checkLoginStatus", { checkOverTime: 1 }, (r) => {
          if (r.ErrorCode == "9999") {
            location.reload();
          } else {
            userFailure(this);
          }
        });
      } else {
        location.reload();
      }
    },
    startPay(code) {
      this.payCode = code;
      //    this.payActive = true;
      $("#modalPayMask").modal("show");
      this.payMaskWait = setInterval(() => {
        $.api_call(
          "api.PayRecord.getStatus",
          {
            payCode: code,
          },
          (r) => {
            if (r.ErrorCode == "9999") {
              if (r.Data.Results == "2" || r.Data.Results == "4") {
                $.api_call(
                  "api.User.checkLoginStatus",
                  { checkOverTime: 1 },
                  (r) => {
                    if (r.ErrorCode == "9999") {
                      let DATA = r.Data.Results;
                      localStorage.setItem("apiUserToken", DATA.token);
                      localStorage.setItem("apiUserId", DATA.id);
                      localStorage.setItem(
                        "apiSubUserId",
                        DATA.subUserId ? DATA.subUserId : 0
                      );
                      store.set("userInfo", DATA);
                      store.set("isLogging", true);
                      sessionStorage.setItem("isApiSuccess", true);
                      location.reload();
                      clearInterval(this.payMaskWait);
                      this.$store.commit('setFTstatus', r.Data.Results.amountStatus)
                    } else {
                      userFailure(this);
                    }
                  }
                );
              }
            } else {
              if (r.ErrorCode == "1002") {
                userFailure(this);
              } else {
                ShowTip(r.Message, "danger");
              }
            }
          }
        );
      }, 3000);
    },
    openSet() {
      this.albumSetOpen2 = Symbol();
      $("#modalAlbumSet2").modal("show");
    },
    saveShare() {
      let params = {};
      if (
        !this.modalShareAlbum.contact &&
        !this.modalShareAlbum.mobile &&
        !this.modalShareAlbum.qq &&
        !this.modalShareAlbum.wangwang &&
        !this.modalShareAlbum.address &&
        !this.modalShareAlbum.province &&
        !this.modalShareAlbum.city &&
        !this.modalShareAlbum.area &&
        !this.modalShareAlbum.postCode
      ) {
        ShowTip(this.$t("product.请填写联系信息"), "danger");
        return;
      }
      params.contactJson = {
        contact: this.modalShareAlbum.contact,
        mobile: this.modalShareAlbum.mobile,
        QQ: this.modalShareAlbum.qq,
        wangwang: this.modalShareAlbum.wangwang,
        address: this.modalShareAlbum.address,
        postCode: this.modalShareAlbum.postCode,
        province: this.modalShareAlbum.province
          ? this.selectCityArr[this.modalShareAlbum.province].name
          : undefined, //$t('product.省份')
        provinceId: this.modalShareAlbum.province
          ? this.selectCityArr[this.modalShareAlbum.province].key
          : undefined,
        city: this.modalShareAlbum.city
          ? this.cityArr[this.modalShareAlbum.city].name
          : undefined, //$t('product.城市')
        area:
          this.modalShareAlbum.area || this.modalShareAlbum.area === 0
            ? this.areaArr[this.modalShareAlbum.area].name
            : undefined, //$t('product.区域')
      };
      params.id = this.configInfo.id ? this.configInfo.id : 0;
      this.modalShareAlbum.loading = true;
      $.api_call("api.SupplierMallConfig.addConfig", params, (r) => {
        this.modalShareAlbum.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("product.保存成功"), "success");
          $("#modalShareAlbum").modal("hide");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    selectProvince() {
      this.modalShareAlbum.city = 0;
      this.modalShareAlbum.area = undefined;
      this.cityArr = [];
      this.areaArr = [];
      let p = this.modalShareAlbum.province;
      if (this.selectCityArr[p] && this.selectCityArr[p].sub) {
        this.cityArr = this.selectCityArr[p].sub;
      } else {
        this.cityArr = [];
      }
    },
    selectCity() {
      this.modalShareAlbum.area = undefined;
      let c = this.modalShareAlbum.city;
      if (!c) return;
      if (this.cityArr[c].sub) {
        this.areaArr = this.cityArr[c].sub;
      } else {
        this.areaArr = [];
      }
    },
    shareAlbum() {
      $.api_call(
        "api.SupplierMall.getShareUrl",
        {
          url: this.userInfo.albumUrl,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            this.setShareImg =
              '<img style="height:150px" class="lottery_icon" src="' +
              r.Data.Results.url +
              '"/>';
          }
        }
      );
      this.loading = true;
      $.api_call("api.SupplierMallConfig.getConfig", {}, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.configInfo = r.Data.Results;
          if (this.configInfo.contactJson) {
            this.modalShareAlbum.contact = this.configInfo.contactJson.contact
              ? this.configInfo.contactJson.contact
              : "";
            this.modalShareAlbum.mobile = this.configInfo.contactJson.mobile
              ? this.configInfo.contactJson.mobile
              : "";
            this.modalShareAlbum.qq = this.configInfo.contactJson.QQ
              ? this.configInfo.contactJson.QQ
              : "";
            this.modalShareAlbum.wangwang = this.configInfo.contactJson.wangwang
              ? this.configInfo.contactJson.wangwang
              : "";

            this.modalShareAlbum.address = this.configInfo.contactJson.address
              ? this.configInfo.contactJson.address
              : "";
            this.modalShareAlbum.postCode = this.configInfo.contactJson.postCode
              ? this.configInfo.contactJson.postCode
              : "";
            this.cityArr = [];
            this.areaArr = [];
            if (this.configInfo.contactJson.province) {
              //$t('product.选省')
              for (let i = 0; i < this.selectCityArr.length; i++) {
                if (
                  this.selectCityArr[i].name ==
                  this.configInfo.contactJson.province
                ) {
                  this.modalShareAlbum.province = i;
                  this.selectProvince();
                  break;
                }
              }
            } else {
              this.modalShareAlbum.province = 0;
            }

            if (this.configInfo.contactJson.city) {
              //$t('product.选市')
              for (let i = 0; i < this.cityArr.length; i++) {
                if (this.cityArr[i].name == this.configInfo.contactJson.city) {
                  this.modalShareAlbum.city = i;
                  if (i > 0) this.selectCity();
                  break;
                }
              }
            } else {
              this.modalShareAlbum.city = 0;
            }

            if (this.configInfo.contactJson.area) {
              //$t('product.选区')
              for (let i = 0; i < this.areaArr.length; i++) {
                if (this.areaArr[i].name == this.configInfo.contactJson.area) {
                  this.modalShareAlbum.area = i;
                  break;
                }
              }
            } else {
              this.modalShareAlbum.area = undefined;
            }
          }
          this.configInfoCopy = JSON.parse(JSON.stringify(this.configInfo));
          this.modalShareAlbum.loading = false;
          $("#modalShareAlbum").modal("show");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    uploadFolderSuccess() {
      //$t('product.上传目录成功回调')
      this.getItems();
    },
    openUpload(type) {
      if (type == "folder") {
        this.openUploadFolder = Symbol();
        $("#modalUploadFolder").modal("show");
      } else {
        this.openUploadPic = Symbol();
        $("#modalUploadPic").modal("show");
      }
    },
    deletesFn() {
      //$t('product.删除')
      this.loading = true;
      $.api_call(
        "api.SupplierAlbum.deleteBySupplier",
        {
          id: this.delAddr.delIndex,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems();
            $(`#${this.delAddr.modalId}`).modal("hide");
            ShowTip(this.$t("product.删除成功"), "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    removeProImg(item) {
      this.delAddr.delIndex = item.id;
      $("#" + this.delAddr.modalId).modal("show");
    },
    setWatermark() {
      this.modalSetMark.loading = false;
      this.modalSetMark.type = 1;
      this.modalSetMark.position = 3;
      $("#modalSetMark").modal("show");
    },
    updateItems(id) {
      this.loading = true;
      $.api_call(
        "api.SupplierMallHelp.findBySupplier",
        {
          id: id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.length == 0) return;
            this.items.forEach((e, i) => {
              if (e.id == r.Data.Results[0].id) {
                this.items.splice(i, 1, r.Data.Results[0]);
              }
            });
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    getItems() {
      if (!this.isSysRights("SupplierAlbum.findBySupplier")) return;
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        status: this.filterProps.status,
        type: this.filterProps.type,
        name: this.filterProps.name,
      };
      $.api_call("api.SupplierAlbum.findBySupplier", params, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.firstLoading = false;
          this.items = r.Data.Results.datas;
          this.size = r.Data.Results.size ? r.Data.Results.size : 0;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    clearKey(type) {
      this.filterProps[type] = "";
      this.toPage(1);
    },
    filtrate(status, type, name) {
      (this.filterProps = {
        status,
        type,
        name,
      }),
        this.toPage(1);
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: "/product-img/" + 1 });
      if (page == 1) {
        this.getItems();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: "/product-img/" + num });
      if (page == num) {
        this.getItems();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
    },
  },
};
</script>

<style lang="less" scoped>
.body-inner {
  [data-id="datepicker-from"],
  [data-id="datepicker-to"] {
    background-color: #fff;
    border-color: rgba(0, 0, 0, 0.15);
    color: #495057;
  }
  ul {
    padding: 0;
    list-style: none;
    margin-bottom: 0;
  }
}
.nav.nav-outline {
  padding: 0 15px;
}
.watermark {
  background: url(/img/9901973926.jpg) no-repeat 0 0;
  background-size: cover;
}
.mark_wrap.class-a {
  bottom: 0;
  right: 0;
}
.mark_wrap.class-b {
  /*bottom: 0;
  left: 50%;
  transform: translateX(-50%);*/
  bottom: 0;
  right: 0;
}
.mark_wrap.class-c {
  bottom: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.mark_wrap.class-d {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.mark_wrap2.class-b {
  top: 0;
  left: 0;
}
</style>